/* global */
import Vuex from 'vuex'
import VuexTurbolinks from '../vuex-turbolinks'

// Store imports
import hotel from './modules/hotel'
import packages from './modules/packages'
import orderItem from './modules/order-item'
import event from './modules/event'


const plugins = [
  VuexTurbolinks
]

export default new Vuex.Store({
  modules: {
    hotel,
    packages,
    orderItem,
    event
  },

  plugins
})
